import dayjs from 'dayjs'
import React, { useState } from 'react'
import { useTranslation } from 'react-i18next'
import { DateTimeInput } from 'semantic-ui-calendar-react'
import CO2Service from '~/api/services/co2'
import Dialog from '~/components/Dialog'
import notify from '~/components/Notify'
import { useAuth } from '~/routes/components/AuthProvider'
import { Nullable } from '~/types'
import { handleErrors, parseDateWithTime } from '~/utils/helpers'

interface Props {
  co2AdjustId: Nullable<string>
  handleClose: (submited?: boolean) => void
}

const AdjustPeriodModal: React.FC<Props> = ({ co2AdjustId, handleClose }) => {
  const { t } = useTranslation()
  const { systemData: { languages, logged: { languageId } } } = useAuth()
  const languageLocal = languages.find(language => language.id === languageId)

  const [isBusy, setIsBusy] = useState(false)
  const [date, setDate] = useState('')

  async function handleSubmit() {
    setIsBusy(true)
    try {
      const parsedDate = parseDateWithTime(date)
      await CO2Service.adjustCO2Period(co2AdjustId, { end: parsedDate })
      setDate('')
      notify(`Der Endzeitraum der Datenerhebung wurde auf ${date} geändert`, 'success')
      handleClose(true)
    } catch (error) {
      handleErrors(error)
    }
    setIsBusy(false)
  }

  function renderDate() {
    const minDate = dayjs().format('DD.MM.YYYY HH:mm')

    return <DateTimeInput
      name='dateTime'
      placeholder={'Zeitraum'}
      minDate={minDate}
      closable
      onKeyDown={(event) => event.preventDefault()}
      markColor={'blue'}
      localization={languageLocal.code}
      closeOnMouseLeave={false}
      dateTimeFormat={'DD.MM.YYYY HH:mm'}
      className={'datePicker'}
      value={date}
      iconPosition='left'
      onChange={(event, { name, value }) => setDate(value)}
    />
  }

  return <Dialog
    isDialogOpen={Boolean(co2AdjustId)}
    disableSubmit={date === ''}
    handleClose={() => {
      setDate('')
      handleClose()
    }}
    isLoading={isBusy}
    textHeader={'Zeitraum anpassen'}
    textContent={renderDate()}
    textSubmit={'Zeiraum anpassen'}
    textClose={t('Close')}
    type={'abort'}
    handleSubmit={() => handleSubmit()}
  />
}
export default AdjustPeriodModal